import { useTranslation } from '@/i18n';

const AdminDashboard = () => {
  const { t } = useTranslation();

  return <div>{t('common.notCreatedYet')}</div>;
};

export default AdminDashboard;
